module.exports = __webpack_public_path__ + "static/media/qualcomm.acc274c2.svg";